import { useMemo } from 'react';

import { useUserTiming } from '@/domains/core/observability/utils/useUserTiming';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import {
  selectFrequentlyBoughtRecommendations,
  selectFrequentlyBoughtRecommendationsConfig,
} from '../../selectors/frequentlyBoughtTogether';
import {
  selectTopProductRecommendations,
  selectTopProductRecommendationsConfig,
} from '../../selectors/similarityTop';
import type { Engine, UseRecoEngineProps } from './useRecoEngine.interfaces';

export const useRecoEngine = (engineType: UseRecoEngineProps): Engine => {
  useUserTiming(`recommendations/useRecoEngine-${engineType}`);

  const memoizedRecoEngine = useMemo(() => {
    if (engineType === 'similarity') {
      return {
        placeHolderSelector: selectTopProductRecommendationsConfig,
        recommendationSelector: selectTopProductRecommendations,
      };
    }

    if (engineType === 'frequentlyBoughtTogether') {
      return {
        placeHolderSelector: selectFrequentlyBoughtRecommendationsConfig,
        recommendationSelector: (
          state: Partial<SpartacuxProductDiscoveryDomainState>,
        ) => selectFrequentlyBoughtRecommendations(state, true),
      };
    }

    return {
      placeHolderSelector: () => undefined,
      recommendationSelector: () => undefined,
    };
  }, [engineType]);

  return memoizedRecoEngine;
};
